import Vue from "vue";
export default {
  setMini(state, payload) {
    state.mini = payload;
    localStorage.setItem("so_mini", JSON.stringify(payload));
  },
  setCurrentDate(state, date) {
    state.curDate = date;
  },
  setFromDate(state, date) {
    state.dateFrom = date;
  },
  setToDate(state, date) {
    state.dateTo = date;
  },
  setPult(state, payload) {
    state.pult = payload;
  },
  setParams(state, payload) {
    state.user = payload.user;
    state.agent = payload.agent;
    state.group = payload.group;
    state.cashier = payload.cashier;
    state.pult = payload.pult;
    state.roles = payload.roles;
  },
  setSnack(state, payload) {
    state.snack = payload;
  },
  setDialog(state, payload) {
    state.dialog = payload;
  },
  setDialogStatus(state, payload) {
    state.dialogStatus = payload;
  },
  setBlank(state, payload) {
    state.blank = payload;
  },
  setOrder(state, payload) {
    state.order = payload;
  },
  setGridFilterOn(state, payload) {
    state.gridFilterOn = payload;
  },
  setFilteredData(state, payload) {
    Vue.set(state.filteredData, payload.id, payload.data);
  },
  setDefaultSearchValue(state, payload) {
    Vue.set(state.searchValue, payload.gridId, payload.value);
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setOrderParams(state, payload) {
    state.orderParams = payload;
  },
  setBlankParams(state, payload) {
    state.blankParams = payload;
  },
  setServicesList(state, payload) {
    state.servicesList = payload;
  },
  setFopList(state, payload) {
    state.fopList = payload;
  },
  setCommonBarScreenParseDialog(state, payload) {
    state.commonBarScreenParseDialog = payload;
  },
  setDocumentsAssignCashierDialog(state, payload) {
    state.documentsAssignCashierDialog = payload;
  },
  setCashierList(state, payload) {
    state.cashierList = payload;
  },
  updateServicesListItemData(state, payload) {
    state.servicesList.find((i) => i["id_bso"] === payload.idBso)[
      payload.field
    ] = payload.value;
  },
  deleteService(state, id) {
    state.servicesList = state.servicesList.filter(
      (item) => item.service_id != id,
    );
  },
  setRowData(state, payload) {
    Vue.set(state.rowData, payload.gridId, payload.data);
  },
  updateOnlineFileOperator(state, payload) {
    payload.ids.forEach((el) => {
      state.documentsList = state.documentsList.map((item) => {
        if (el == item.ID) {
          return {
            ...item,
            Operator: payload.Operator,
          };
        }
        return item;
      });
    });
  },
  setDocumentsList(state, payload) {
    state.documentsList = payload;
  },
  updateDocumentsItem(state, payload) {
    const current = state.documentsList?.find((item) =>
      item.Numbers.includes(payload),
    );
    if (current) {
      const nums = current.Numbers.trim()
        .split(" ")
        .filter((num) => num !== payload.trim());
      current.Numbers = nums.join(" ");
    }
  },
  setDocumentsDeep(state, payload) {
    state.documentsDeep = payload;
  },
  setPayCodes(state, payload) {
    state.payCodes = payload;
  },
  setPayTypes(state, payload) {
    state.payTypes = payload;
  },
  setMainMenu(state, payload) {
    state.mainMenu = payload;
  },
  setSettingsMenu(state, payload) {
    state.settingsMenu = payload;
  },

  setInsurance(state, payload) {
    state.insurance = payload;
  },
  setInsuranceParams(state, payload) {
    state.insuranceParams = payload;
  },

  deleteSavedAsb(state, id) {
    state.documentsList = state.documentsList.filter((item) => item.ID !== id);
  },
  deleteGroupSavedAsb(state, ids) {
    state.documentsList = state.documentsList.filter(
      (item) => !ids.includes(item.ID),
    );
  },

  setToken(state, token) {
    state.tokenForOld = token;
  },
  setCurrentGrid(state, payload) {
    state.currentGrid = payload;
  },
  setGridFilters(state, payload) {
    Vue.set(state.gridFilters, payload.grid, payload.value);
  },
  deleteGridFilter(state, payload) {
    delete state.gridFilters[payload];
  },
  updateSearchValue(state, payload) {
    Vue.set(state.searchValue, payload.searchId, payload.value);
  },
  setDailyReportsList(state, payload) {
    state.dailyReports = payload;
  },

  setParsersList(state, payload) {
    state.parsersList = payload;
  },
  setReportNewVersionAccess(state, payload) {
    state.reportNewVersionAccess = payload.map((el) => el.agcod);
  },
  setExternalFilterDialog(state, payload) {
    state.externalFilterDialog = payload;
  },
  setFilteredColumns(state, payload) {
    state.filteredColumns = payload;
  },
  setFilteredClients(state, payload) {
    state.filteredClients = payload;
  },
  setPeriodClients(state, payload) {
    state.periodClients = payload;
  },
  setColumnsOnGrid(state, payload) {
    Vue.set(state.columnsOnGrid, payload.gridId, payload.data);
  },
  setReportsAdditionalList(state, payload) {
    state.reportsAdditionalList = payload;
  },
  setAdditionalTableTemplates(state, payload) {
    state.additionalTableTemplates = payload;
  },
  removeAdditionalTableTemplate(state, payload) {
    state.additionalTableTemplates = state.additionalTableTemplates.filter(
      (t) => t.id !== payload,
    );
  },
  setCurrentAdditionalReport(state, payload) {
    state.currentAdditionalReport = payload;
  },
  setAdditionalReportData(state, payload) {
    state.additionalReportData = payload;
  },
  removeTableTemplate(state, payload) {
    state.additionalTableTemplates = state.additionalTableTemplates?.filter(
      (t) => t.id !== payload,
    );
  },
  deleteServiceFromAdditionalReportData(state, id) {
    if (state.additionalReportData != null) {
      state.additionalReportData = state.additionalReportData?.filter(
        (item) => item.id_bso !== id,
      );
    }
  },
  deleteServiceFromAgencyReports(state, id) {
    if (state.servicesList != null) {
      state.servicesList = state.servicesList?.filter(
        (item) => item?.id_bso != id,
      );
    }
  },
};
